// Linea simulada: mismo contrato que la SIP, sin red. Sirve para demostrar la Consola,
// capacitar agentes y para las pruebas automaticas. Nunca marca a numeros reales.

import { Emitter, type CallHandle, type EndInfo, type Line, type LineConfig, type LineStatus } from './line';

let seq = 0;

export class SimCall implements CallHandle {
  readonly id = `sim-${++seq}`;
  private ev = new Emitter<'progress' | 'accepted' | 'ended' | 'failed'>();
  private done = false;
  private timers: ReturnType<typeof setTimeout>[] = [];
  held = false;
  muted = false;
  dtmf = '';

  constructor(
    readonly direction: 'in' | 'out',
    readonly remote: string,
    readonly remoteName?: string,
    opts: { answerAfter?: number } = {},
  ) {
    if (direction === 'out') {
      this.timers.push(setTimeout(() => this.ev.emit('progress'), 500));
      this.timers.push(setTimeout(() => this.accept(), opts.answerAfter ?? 1800));
    }
  }

  on(event: 'progress' | 'accepted' | 'ended' | 'failed', cb: ((info: EndInfo) => void) | (() => void)) {
    this.ev.on(event, cb as () => void);
  }

  private accept() {
    if (this.done) return;
    this.ev.emit('accepted');
  }

  private finish(kind: 'ended' | 'failed', cause: string, byRemote: boolean) {
    if (this.done) return;
    this.done = true;
    this.timers.forEach(clearTimeout);
    this.ev.emit(kind, { cause, byRemote });
  }

  answer() {
    this.accept();
  }
  reject(_codigo?: 480 | 486) {
    this.finish('failed', 'Rejected', false);
  }
  hangup() {
    this.finish('ended', 'Terminated', false);
  }
  // Para simular que el cliente cuelga.
  remoteHangup() {
    this.finish('ended', 'BYE', true);
  }
  setMuted(m: boolean) {
    this.muted = m;
  }
  setHold(h: boolean) {
    this.held = h;
  }
  sendDtmf(t: string) {
    this.dtmf += t;
  }
  async transferBlind(target: string) {
    if (!target) throw new Error('Destino vacío');
    await new Promise((r) => setTimeout(r, 300));
    this.finish('ended', 'Transferred', false);
  }
  async transferAttended(consult: CallHandle) {
    await new Promise((r) => setTimeout(r, 300));
    (consult as SimCall).finish('ended', 'Transferred', false);
    this.finish('ended', 'Transferred', false);
  }
  playAudio() {}
}

export class SimLine implements Line {
  readonly kind = 'sim' as const;
  status: LineStatus = 'desconectado';
  statusDetail = 'Modo demostración';
  private ev = new Emitter<'status' | 'incoming'>();

  onStatus(cb: (s: LineStatus, detail: string) => void) {
    return this.ev.on('status', cb as never);
  }
  onIncoming(cb: (c: CallHandle) => void) {
    return this.ev.on('incoming', cb as never);
  }
  connect(_cfg?: LineConfig) {
    this.status = 'en-linea';
    this.statusDetail = 'Modo demostración: las llamadas son simuladas.';
    this.ev.emit('status', this.status, this.statusDetail);
  }
  disconnect() {
    this.status = 'desconectado';
    this.statusDetail = 'Modo demostración apagado.';
    this.ev.emit('status', this.status, this.statusDetail);
  }
  call(target: string): CallHandle {
    return new SimCall('out', target);
  }
  // Genera una llamada entrante de prueba.
  ring(numero: string, nombre?: string) {
    const c = new SimCall('in', numero, nombre);
    this.ev.emit('incoming', c);
    return c;
  }
}
